import script from "./WageCompareAfter.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageCompareAfter.vue?vue&type=script&setup=true&lang=ts"

import "./WageCompareAfter.vue?vue&type=style&index=0&id=3cd2f47c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd2f47c"]])

export default __exports__